import { combineReducers } from 'redux';
import { eADMIN_reducer } from './Reducer/eADMIN';
import { eCOMPANY_reducer } from './Reducer/eCOMPANY';
import { eUSER_reducer } from './Reducer/eUSER';
import { eDISTRIBUTOR_reducer } from './Reducer/eDISTRIBUTOR';
import { ePRODUCT_reducer } from './Reducer/ePRODUCT';
import { eFILE_reducer } from './Reducer/eFILE';
import { eDATA_reducer } from './Reducer/eDATA';
import { eLOG_reducer } from './Reducer/eLOG';
import { eSESSION_reducer } from './Reducer/eSESSION';

export const action = {
   eUSER: require('./Action/eUSER'),
   eDISTRIBUTOR: require('./Action/eDISTRIBUTOR'),
   eADMIN: require('./Action/eADMIN'),
   eEVENT: require('./Action/eEVENT'),
   eCOMPANY: require('./Action/eCOMPANY'),
   ePRODUCT: require('./Action/ePRODUCT'),
   eFILE: require('./Action/eFILE'),
   eDATA: require('./Action/eDATA'),
   eLOG: require('./Action/eLOG'),
   eSESSION: require('./Action/eSESSION'),
}

export const reducer = combineReducers({
   eUSER: eUSER_reducer,
   eDISTRIBUTOR: eDISTRIBUTOR_reducer,
   eADMIN: eADMIN_reducer,
   eCOMPANY: eCOMPANY_reducer,
   ePRODUCT: ePRODUCT_reducer,
   eFILE: eFILE_reducer,
   eDATA: eDATA_reducer,
   eLOG: eLOG_reducer,
   eSESSION: eSESSION_reducer,
});
